import { api } from './client';

/** One friend in the player's list — mirrors the server's FriendSummary. */
export interface FriendSummary {
  playerId: string;
  displayName: string;
  online: boolean;
  lastSeenEpochSeconds: number | null;
}

/** The player's friends (seeded by viral-invite redemptions), newest first. */
export function getFriends(playerId: string): Promise<FriendSummary[]> {
  return api<FriendSummary[]>(`/players/${encodeURIComponent(playerId)}/friends`);
}
